import $ from "jquery";

import AP from "../legacy/global";

// live-chat documentation: https://www.mycontactual.com/api/embeddedchat/

export const settings = AP?.config?.envConfig?.liveChat
  ? {
      tenant: "c2FnZXN1cmUwMQ",
      domain: "https://vcc-na7.8x8.com",
      path: "/.",
      buttonContainerId: "live-chat-8x8",
      align: "right"
    }
  : null;

export const getLiveChatSettings = (userData, roles = []) => {
  const {
    stylesheetURL,
    stylesheetEliteURL,
    uuid,
    channel,
    eliteChannel,
    eliteUuid,
    personalCommercialUuid,
    personalCommercialChannel,
    personalCommercialEliteUuid,
    personalCommercialEliteChannel,
    commercialUuid,
    commercialChannel,
    commercialEliteUuid,
    commercialEliteChannel
  } = AP.config.envConfig.liveChat;

  const mapper = {
    regular: {
      commercial: {
        uuid: commercialUuid,
        channel: commercialChannel
      },
      personal: {
        uuid,
        channel
      },
      personalCommercial: {
        uuid: personalCommercialUuid,
        channel: personalCommercialChannel
      }
    },
    elite: {
      commercial: {
        uuid: commercialEliteUuid,
        channel: commercialEliteChannel
      },
      personal: {
        uuid: eliteUuid,
        channel: eliteChannel
      },
      personalCommercial: {
        uuid: personalCommercialEliteUuid,
        channel: personalCommercialEliteChannel
      }
    }
  };

  const personalMatchers = ["_DP_", "_SL_", "_HO_", "_WIC_"];
  const commercialMatchers = ["_BOP_"];

  const hasPersonal = roles.find(role =>
    personalMatchers.find(matcher => role.includes(matcher))
  );
  const hasCommercial = roles.find(role =>
    commercialMatchers.find(matcher => role.includes(matcher))
  );
  const isElite =
    userData?.ProgramStatus?.toLowerCase().indexOf("diamond") > -1 ||
    userData?.PerkStatus?.indexOf("Elite_Line_Access") > -1;

  let key;
  if (hasPersonal && hasCommercial) {
    key = "personalCommercial";
  } else if (hasCommercial) {
    key = "commercial";
  } else {
    key = "personal";
  }

  const values = mapper[isElite ? "elite" : "regular"][key];

  return {
    channel: values.channel,
    uuid: values.uuid,
    stylesheetURL: `${window.location.origin}${
      isElite ? stylesheetEliteURL : stylesheetURL
    }`
  };
};

export const loadLiveChat = (userData, roles) => {
  if (!settings) return;
  window.__8x8Chat = {
    ...settings,
    ...getLiveChatSettings(userData, roles),
    onInit: bus => {
      bus.publish("customer:set-info", userData);
      $("#live-chat-8x8").attr({
        class: "livechat",
        "data-track": "Footer: Support Chat"
      });
    }
  };
  $.getScript(`${settings.domain}${settings.path}/CHAT/common/js/chat.js`);
};
